/** Data-driven stages / biomes — unlock with coins, each tweaks feel + rewards. */

export type StageId = "neon" | "lunar" | "volcano" | "ice";

export type StageDef = {
  id: StageId;
  name: string;
  blurb: string;
  price: number;
  /** Soft-currency multiplier on top of difficulty × vehicle. */
  coinMult: number;
  /** Extra jump height/duration vs baseline. */
  jumpMult: number;
  /** Chance a ground hazard is a hole (must jump). */
  holeChance: number;
  fog: string;
  ground: string;
  rail: string;
  railEmissive: string;
  buildingHueA: string;
  buildingHueB: string;
  skyHint: string;
};

export const STAGES: StageDef[] = [
  {
    id: "neon",
    name: "Neon City",
    blurb: "Rain-slick lanes. The classic 3Dash run.",
    price: 0,
    coinMult: 1,
    jumpMult: 1,
    holeChance: 0,
    fog: "#070B18",
    ground: "#0F172A",
    rail: "#E879F9",
    railEmissive: "#C026D3",
    buildingHueA: "#22D3EE",
    buildingHueB: "#E879F9",
    skyHint: "Night metro",
  },
  {
    id: "lunar",
    name: "Lunar Dust",
    blurb: "Low gravity — jumps float. +25% coins.",
    price: 500,
    coinMult: 1.25,
    jumpMult: 1.45,
    holeChance: 0,
    fog: "#0B1020",
    ground: "#1E293B",
    rail: "#94A3B8",
    railEmissive: "#64748B",
    buildingHueA: "#E2E8F0",
    buildingHueB: "#38BDF8",
    skyHint: "Pale crater glow",
  },
  {
    id: "volcano",
    name: "Magma Run",
    blurb: "Lava cracks — jump the holes. +50% coins.",
    price: 900,
    coinMult: 1.5,
    jumpMult: 1.05,
    holeChance: 0.28,
    fog: "#1A0A08",
    ground: "#1C1917",
    rail: "#F97316",
    railEmissive: "#C2410C",
    buildingHueA: "#FB923C",
    buildingHueB: "#EF4444",
    skyHint: "Ash & ember",
  },
  {
    id: "ice",
    name: "Ice Flats",
    blurb: "White-out speed. Long jumps, thin ice holes. +20% coins.",
    price: 700,
    coinMult: 1.2,
    jumpMult: 1.25,
    holeChance: 0.16,
    fog: "#0A1220",
    ground: "#0F2744",
    rail: "#7DD3FC",
    railEmissive: "#38BDF8",
    buildingHueA: "#E0F2FE",
    buildingHueB: "#67E8F9",
    skyHint: "Frozen dusk",
  },
];

export const STAGE_BY_ID = Object.fromEntries(
  STAGES.map((s) => [s.id, s]),
) as Record<StageId, StageDef>;

export const DEFAULT_STAGE_ID: StageId = "neon";

export function isStageId(id: unknown): id is StageId {
  return typeof id === "string" && id in STAGE_BY_ID;
}
